
import { defineComponent } from 'vue';
import BrandingMixin from '@/mixins/BrandingMixin';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import CustomDialog from '~/components/Dialogs/CustomDialog.vue';
import { LoanDetailsData } from '@/interfaces/loan';
import { PaymentOptions } from '@/interfaces/payment-options';

export default defineComponent({
  name: 'RecurringPaymentsTermsDialog',

  mixins: [BrandingMixin],

  components: {
    CustomButton,
    CustomDialog,
  },

  props: {
    paymentMethodType: { type: String, required: true },
  },

  computed: {
    lenderName(): string {
      return this.$store.getters['Loan/getLender'];
    },

    loanData(): LoanDetailsData {
      return this.$store.getters['Loan/getLoanData'];
    },

    bankPayment() {
      return this.paymentMethodType === PaymentOptions.BANK;
    },

    cardPayment() {
      return this.paymentMethodType === PaymentOptions.CARD;
    },
  },
});
